// OrganizationAccount GraphQL queries matching backend schema

export const listOrganizationAccounts = `
   query listOrganizationAccounts($filter: OrganizationAccountsFilterInput, $limit: Int, $nextToken: String) {
       listOrganizationAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              organizationId
              accountId
              organizationAccountStatus
              account {
                id
                sub
                username
                email
                accountType
                accountStatus
              }
              organization {
                id
                name
                adminAccountId
              }
              created
              updated
           }
           nextToken
       }
   }
`;

export const getOrganizationAccount = `
   query getOrganizationAccount($id: ID!) {
       getOrganizationAccount(id: $id) {
         id
         organizationId
         accountId
         organizationAccountStatus
         account {
           id
           sub
           username
           email
           accountType
           accountStatus
         }
         organization {
           id
           name
           adminAccountId
         }
         created
         updated
       } 
   }
`;